<template>
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="id"
      :itemNames="['create_button',]"
      :columns="getColumns()"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="create_button">
        <a-button @click="openDialog">绑定商品</a-button>
      </a-form-item>
      <div slot="auditSlots" slot-scope="rowItem">
        <a-tooltip placement="topLeft">
          <template slot="title" v-if="rowItem.record.auditReason">{{ rowItem.record.auditReason }}</template>
          <div class="pro_title">{{ rowItem.record.auditStatusStr }}</div>
        </a-tooltip>
      </div>
      <div slot="action" slot-scope="rowItem">
        <template>
          <a @click="onDeleteEvent(rowItem.record.bindId)">删除绑定</a>
        </template>
      </div>
    </search-page-view>
    <a-modal title="手动同步" :visible="dialogVisible" width="650px" :footer="null" @cancel="handleCancel">
      <a-form-model
        :model="ruleForm" ref="ruleForm" :rules="rules"
        :label-col="currentFormLayout.labelCol"
        :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="所属供应商" prop="accountId">
          <a-select allowClear v-model="ruleForm.accountId" placeholder="请选择" @change="handleAccountChange">
            <a-select-option v-for="item in accountList" :value="item.accountId" :key="item.accountId">
              {{ item.supplyName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="选择商品" required>
          <a-button type="primary" @click="toSelectedProductEvent">选择商品</a-button>
          <span v-if="ruleForm.productId" style="margin-left: 3px;">商品ID:{{ ruleForm.productId }}</span>
          <span style="margin-left: 3px;">*仅能关联门票类型且未上架的自有商品</span>
        </a-form-model-item>
        <a-form-model-item label="商品名称">
          <a-input v-model="productName" :disabled="true" placeholder="请输入商品名称" :maxLength="100"></a-input>
        </a-form-model-item>
        <a-form-model-item label="选择票型" prop="optionId">
          <a-select allowClear v-model="ruleForm.optionId" placeholder="请选择">
            <a-select-option v-for="item in optionList" :value="item.optionId" :key="item.optionId">
              {{ item.optionName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="供应商商品类型" required>
          <a-select allowClear v-model="productCatalog" placeholder="请选择" @change="handelChange">
            <a-select-option :value="1">门票</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="供应商商品名称" prop="cmypProductNo">
          <a-select allowClear v-model="ruleForm.cmypProductNo" placeholder="请选择">
            <a-select-option v-for="item in productCMYList" :value="item.productNo" :key="item.productNo">
              {{ item.productName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <selected-product-dialog
      :show="showSelectedDialog"
      ref="pageList"
      :itemNames="['search_proId','search_proName']"
      :query-params="selectedQueryParams"
      :requestPromise="loadProductPromise"
      row-key="proId"
      @close="handleProductCancel"
      :columns="getGoodsColumns()"
    >
      <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <template slot="proTypeSlot" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import ChaoMaiMixins from '@/views/service/serviceProvider/chaoMaiCloud/mixins/ChaoMaiMixins'

export default {
  name: 'ChaoMaiProductSync',
  components: { SelectedProductDialog },
  mixins: [ChaoMaiMixins],
  data() {
    return {
      ruleForm: {
        accountId: undefined,// 供应商账号id ,
        cmypProductNo: undefined,// 超麦云票商品编号 ,
        cmypProductName: '',
        optionId: undefined,// 票型id ,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        productId: ''// 商品id
      },
      rules: {
        accountId: [
          { required: true, message: '请选择供应商', trigger: 'change' }
        ],
        optionId: [
          { required: true, message: '请选择票型', trigger: 'change' }
        ],
        cmypProductNo: [
          { required: true, message: '请选择供应商商品', trigger: 'change' }
        ]
      },
      queryParams: {},
      selectedQueryParams: {
        proName: '',
        proId: '',
        proSource: 0,
        proStatus: 0,
        proType: 1,
        proJoinType: 0
      },
      optionList: [],
      accountList: [],
      selectTypeList: [],
      loadPromise: params => this.getListPromise(params),
      loadProductPromise: params => this.getProductListPromise(params),
      productName: '',
      dialogVisible: false,
      showSelectedDialog: false,
      productCatalog: 1,
      productCMYList: []
    }
  },
  mounted() {
    this.getAccountList()
  },
  methods: {
    onPageSearch() {
      this.$refs.table.refresh(true)
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getProService().post('direct/cmyp/bind/list/page', params)
    },
    getProductListPromise(params) {
      return this.getHttpServices().getProService().post('api/v2/productManage/findProductList', params)
    },
    handleProductCancel() {
      this.showSelectedDialog = false
    },
    handleCancel() {
      this.dialogVisible = false
    },
    onDeleteEvent(bindId) {
      const params = { bindId }
      this.getHttpServices().getServerApiService().post('cmyp/product/unBind', params).then(res => {
        this.$refs.table.refresh(true)
        this.$message.success('解绑成功')
      }).catch(err => {
        this.getLogUtils().logWithTag('onUpdateEvent', err)
        this.$message.error(err.msg)
      })
    },
    openDialog() {
      this.dialogVisible = true
      this.ruleForm = {
        accountId: undefined,// 供应商账号id ,
        cmypProductNo: undefined,// 超麦云票商品编号 ,
        optionId: undefined,// 票型id ,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        productId: '',// 商品id
        cmypProductName: ''
      }
    },
    //商品数据点击
    onSelectedResult(record) {
      this.productName = record.proName
      this.ruleForm.productId = record.proId
      this.showSelectedDialog = false
      this.getOptionList()
    },
    //选择商品
    toSelectedProductEvent() {
      this.showSelectedDialog = true
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      params.cmypProductName = this.productCMYList.filter(item => item.productNo)[0].productName
      this.getHttpServices().getServerApiService().post('cmyp/product/bind', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('商品绑定成功')
        this.dialogVisible = false
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    getAccountList() {
      const params = {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }
      this.getHttpServices().getServerApiService().post('cmyp/account/list', params).then(res => {
        this.getLogUtils().logWithTag('getAccountList', res)
        this.accountList = res && res.length > 0 ? res : []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleAccountChange(value) {
      this.ruleForm.accountId = value
      this.getCMYProductList()
    },
    handelChange(value) {
      console.error('handelChange', value)
      this.productCatalog = value
      this.getCMYProductList()
    },
    getCMYProductList() {
      const params = {
        accountId: this.ruleForm.accountId,
        productCatalog: this.productCatalog
      }
      this.ruleForm.cmypProductNo = undefined
      this.getHttpServices().getServerApiService().post('cmyp/product/list', params).then(res => {
        this.getLogUtils().logWithTag('getCMYProductList', res)
        this.productCMYList = res && res.length > 0 ? res : []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getOptionList() {
      const params = {
        productId: this.ruleForm.productId,
        joinType: 0
      }
      this.getHttpServices().getProService().post('product/option/list', params).then(res => {
        this.getLogUtils().logWithTag('getOptionList', res)
        this.optionList = res && res.length > 0 ? res : []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'productId'
        },
        {
          title: '商品名称',
          dataIndex: 'productName'
        },
        {
          title: '超麦云商品名称',
          dataIndex: 'cmypProductName'
        },
        {
          title: '票型',
          dataIndex: 'optionName'
        },
        {
          title: '供应商名称',
          dataIndex: 'supplyName'
        },
        {
          title: '更新时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '160px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品分类',
          dataIndex: 'proType',
          width: '100px',
          scopedSlots: { customRender: 'proTypeSlot' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }

}
</script>
<style scoped lang="less">

</style>